import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, resolveDirective as _resolveDirective, mergeProps as _mergeProps, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27998ae7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "upload-btn" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-dianjishangchuan" }, null, -1))
const _hoisted_3 = { class: "text" }
const _hoisted_4 = ["href"]

import { t } from '@/plugins/i18n'
import { reactive, ref, watch } from 'vue'
import { Delete, Loading } from '@element-plus/icons-vue'
import { getSign } from '@/apis/oss'
import useFileUtils from '@/util/useFileUtils'
import { uid } from 'uid/dist/index.js'
import { ElMessage } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  props: {
  limit: {
    type: Number,
    default: 1
  },
  // 文件类型
  limitFile: {
    type: Object,
    default: () => ({
      accept: '.pdf,.doc,.docx,.xls,.xlsx'
    })
  }
},
  emits: ['change', 'getName'],
  setup(__props, { emit }) {

const props = __props
const isLoading = ref(false)


const { getExtension } = useFileUtils()
const host = ref('')
const uploadParams = reactive({
  name: '',
  key: '',
  policy: '',
  OSSAccessKeyId: '',
  success_action_status: 200,
  signature: ''
})
const fileList: any = ref([])
const delFile = () => {
  fileList.value = []
  handleChange()
}

const beforeUploadValidator: any = {
  '.pdf,.doc,.docx,.xls,.xlsx': (file: any) => {
    const { getExtension } = useFileUtils()
    const ext = getExtension(file.name)
    const limitList = ['pdf', 'doc', 'docx', 'xls', 'xlsx']
    if (!limitList.includes(ext)) {
      ElMessage.warning(t('上传文件只能是X格式').replace('X', limitList.join('/').toUpperCase()))
      return false
    }
    const size = file.size / 1024 / 1024
    if (size > 50) {
      ElMessage.warning('文件大小不超过50m')
      return false
    }
    return true
  },
  '.jpg,.jpeg,.png,.JPG,.JPEG,.PNG': (file: any) => {
    const { getExtension } = useFileUtils()
    const ext = getExtension(file.name)
    const limitList = ['jpg', 'jpeg', 'png', 'JPG', 'JPEG', 'PNG']
    console.log(ext)
    if (!limitList.includes(ext)) {
      ElMessage.warning(t('上传文件只能是X格式').replace('X', [...new Set(limitList.map(v => v.toUpperCase()))].join('/')))
      return false
    }
    const size = file.size / 1024 / 1024
    if (size > 50) {
      ElMessage.warning('文件大小不超过50m')
      return false
    }
    return true
  },
  '.jpg,.jpeg,.png,.JPG,.JPEG,.PNG,.pdf': (file: any) => {
    const { getExtension } = useFileUtils()
    const ext = getExtension(file.name)
    const limitList = ['jpg', 'jpeg', 'png', 'JPG', 'JPEG', 'PNG', 'pdf']
    console.log(ext)
    if (!limitList.includes(ext)) {
      ElMessage.warning(t('上传文件只能是X格式').replace('X', [...new Set(limitList.map(v => v.toUpperCase()))].join('/')))
      return false
    }
    const size = file.size / 1024 / 1024
    if (size > 50) {
      ElMessage.warning('文件大小不超过50m')
      return false
    }
    return true
  }
}

const beforeUpload = (file: any) => {
  emit('getName', file.name)
  console.log('beforeUpload', props.limitFile?.accept, file)
  if (beforeUploadValidator[props.limitFile?.accept](file)) {
    isLoading.value = true
    return getOssSign(file)
  }
  return false
}

const handleChange = () => {
  console.log('上传完成！')
  isLoading.value = false
  emit('change', fileList.value[0])
}

/**
 * 获取阿里云上传签名等参数
 */
const getOssSign = (file: any) => {
  return new Promise((resolve: any, reject: any): any => {
    getSign()
      .then((res: any) => {
        const data = res.data
        uploadParams.name = file.name
        uploadParams.key = `${data.dir}${uid()}`
        const ext = getExtension(file.name)
        if (ext && ext.length > 0) {
          uploadParams.key = `${uploadParams.key}.${ext}`
        }
        uploadParams.policy = data.policy
        uploadParams.OSSAccessKeyId = data.accessId
        uploadParams.signature = data.signature

        host.value = data.host.replace(/http[s]?:/, location.protocol)
        // this.customDomain = data.customDomain
        // // 上传后文件的访问url
        // file.url = `${this.customDomain}/${this.uploadParams.key}`
        console.log(`${data.customDomain}/${uploadParams.key}`)
        file.url = `${data.customDomain}/${uploadParams.key}`
        resolve(true)
      })
      .catch((error) => {
        console.error('error', error)
        reject(new Error())
      })
      .finally(() => {
        // do nothing
      })
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_upload, _mergeProps({
    ref: (_value, _refs) => {
      _refs['uploadRef'] = _value
    },
    class: "uploader flex",
    accept: __props.limitFile?.accept,
    "before-upload": (beforeUpload as any),
    limit: __props.limit,
    action: host.value,
    data: _unref(uploadParams),
    "show-file-list": false,
    "file-list": fileList.value
  }, _ctx.$attrs, { onSuccess: handleChange }), {
    trigger: _withCtx(() => [
      _renderSlot(_ctx.$slots, "trigger", _normalizeProps(_guardReactiveProps({ delFile: delFile })), () => [
        _withDirectives(_createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('点击上传')), 1)
        ], 512), [
          [_vShow, fileList.value.length < __props.limit]
        ]),
        _withDirectives(_createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (i) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              class: "uploader-list flex-bwn-ter",
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
              key: i
            }, [
              _createElementVNode("a", {
                href: i.raw?.url,
                target: "_blank"
              }, _toDisplayString(i.name), 9, _hoisted_4),
              _createVNode(_component_el_icon, {
                size: 16,
                onClick: delFile
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Delete))
                ]),
                _: 1
              })
            ], 512)), [
              [_directive_loading, isLoading.value]
            ])
          }), 128))
        ], 512), [
          [_vShow, fileList.value.length]
        ])
      ])
    ]),
    tip: _withCtx(() => [
      _renderSlot(_ctx.$slots, "tip")
    ]),
    _: 3
  }, 16, ["accept", "before-upload", "limit", "action", "data", "file-list"]))
}
}

})